import React from "react";
import { Input, Button } from "antd";
import { PlusOutlined, SearchOutlined } from "@ant-design/icons";
import { Modal, Popover } from "antd";

import styles from "../../styles/Registers.module.css";

export const Heading = ({
  searchValue,
  onSearch,
  onCreateReportTypeClicked,
}) => {
  return (
    <div className={styles.headingActions}>
      <div className={styles.searchInput}>
        <Input
          placeholder="Pretraži"
          value={searchValue}
          suffix={<SearchOutlined />}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      <Popover content="Dodaj pregled" trigger="hover">
        <div>
          <Button
            type="primary"
            className={styles.addButton}
            onClick={onCreateReportTypeClicked}
          >
            <PlusOutlined />
            Dodaj
          </Button>
        </div>
      </Popover>
    </div>
  );
};
